
define(
	'TavanoTeamStaging.AnchorScroll_Extension.AnchorScroll'
	, []
	, function () {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {
					// Warning Top Icon Event - Scroll to Warning Tab
					layout.on('afterShowContent', function () {

						$(document).on('click', 'a[data-tt-scrollto]', function (e) {
							var target_id = e.currentTarget.getAttribute('data-tt-scrollto')
							var target_element = $('#' + target_id);

							if (target_element.length > 0) {
								var targetOffset = target_element.offset().top;

								// Open Warning Tab if closed
								if(target_id === 'warning-tab-button') {
									if($('#warning-tab-button').hasClass('collapsed')) {
										$('#warning-tab-button').click();
									}
								}

								// Subtract sticky header hight to scroll top position
								var mainHeader = $('header');
								if (mainHeader.css('position') === 'sticky') {
									targetOffset = targetOffset - mainHeader.height() + $("header .header-main-wrapper").position().top;
								}

								// Animate scrolling to the target element
								$('html, body').animate({ scrollTop: targetOffset }, 1000); // Adjust the duration as needed
							}
						}); 
					});
				}
			}
		};
	});
